import _, { shuffle } from "lodash";

const state = {
    images: [
        "https://magnum-xl.com/img/Slider/boy1.jpg",
        "https://magnum-xl.com/img/Slider/boy2.jpg",
        "https://magnum-xl.com/img/Slider/boy3.jpg",
        "https://magnum-xl.com/img/Slider/boy4.jpg",
        "https://magnum-xl.com/img/Slider/boy6.jpg",
        "https://magnum-xl.com/img/Slider/girl1.jpg",
        "https://magnum-xl.com/img/Slider/girl2.jpg",
        "https://magnum-xl.com/img/Slider/girl4.jpg",
        "https://magnum-xl.com/img/Slider/girl5.jpg",
        "https://magnum-xl.com/img/Slider/girl6.jpg",
        "https://magnum-xl.com/img/Slider/girl7.jpg",
        "https://magnum-xl.com/img/Slider/girl8.jpg",
    ],
    uniqueLeft: [],
    uniqueRight: [],
};
const getters = {
    uniLeft: state => state.uniqueLeft,
    uniRight: state => state.uniqueRight,
};

const actions = {
    async imagesMixerAction({ commit }) {
        commit('imagesMixer');
    }
};
const mutations = {
    imagesMixer(state) {
        const images = _.shuffle(state.images);
        const uniqueLeft = [];
        const uniqueRight = [];
        for (let i = 0; i < images.length; i++) {
            if (i % 2 === 0) {
                uniqueLeft.push(images[i]);
            } else {
                uniqueRight.push(images[i]);
            }
        }

        state.uniqueLeft = _.shuffle(uniqueLeft);
        state.uniqueRight = _.shuffle(uniqueRight);
    }
};
export default {
    state,
    getters,
    actions,
    mutations
};
